import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location } from 'lib/componentLocation';
import { ManagePilotLookups, ManagePilotLookupsParams } from './model';
import { ManagePilotLookupsView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function ManagePilotLookupsRoute(
    model : (params : ManagePilotLookupsParams) => ManagePilotLookups,
    appWrapper : AppWrapper,
    request : Location
) : IRoute {
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <ManagePilotLookupsView model={model(inboundParams(request))} />
            </AppWrapperView>
    };
}

function inboundParams(request : Location) : ManagePilotLookupsParams {
    return {
        id: +(request.params['id'] || 0)
    };
}


// WEBPACK FOOTER //
// ./apps/pilots/managepilotlookups/route.tsx